export default __webpack_public_path__ + "static/team-member-1-36edf0b1bef736fe366a8c82dda0703e.png";